<script lang="ts">
  import type { Snippet } from "svelte";
  import AppLogo from "$lib/components/AppLogo.svelte";
  import HeroBackdrop from "$lib/components/HeroBackdrop.svelte";
  interface Props {
    title: string;
    subtitle?: string | undefined;
    children: Snippet;
    footer?: Snippet;
  }
  const { title, subtitle, children, footer }: Props = $props();
</script>

<main id="main-content" class="auth-shell">
  <HeroBackdrop />
  <div class="auth-card">
    <div class="brand">
      <AppLogo size={34} />
      <span>EpiDev</span>
    </div>
    <h1 class="page-title" data-page-title tabindex="-1">{title}</h1>
    {#if subtitle}<p class="auth-sub">{subtitle}</p>{/if}
    <div class="auth-body">{@render children()}</div>
    {#if footer}<div class="auth-footer">{@render footer()}</div>{/if}
  </div>
</main>

<style>
  .auth-shell {
    position: relative;
    /* Contains the backdrop's absolute layers and keeps its stacking context local,
       so nothing it paints can reach over a dialog or toast rendered elsewhere. */
    isolation: isolate;
    overflow: hidden;
    min-height: 100vh;
    display: grid;
    place-items: center;
    padding: 24px;
  }
  .auth-card {
    /* Above the backdrop. The card is opaque and in flow, the backdrop is absolute
       and out of it, so the two never overlap as content. */
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 420px;
    background: var(--surface);
    border: 1px solid var(--line-soft);
    border-radius: var(--radius);
    padding: 32px 30px;
  }
  .brand {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 600;
    color: var(--heading);
    /* The site pins its brand lockup to letter-spacing: 0; so does this one. */
    letter-spacing: 0;
    margin-bottom: 24px;
  }
  .page-title {
    font-size: 22px;
    letter-spacing: 0;
    margin-bottom: 6px;
  }
  .auth-sub {
    color: var(--muted);
    font-size: 14.5px;
    margin: 0 0 22px;
  }
  .auth-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .auth-footer {
    margin-top: 22px;
    padding-top: 18px;
    border-top: 1px solid var(--line-soft);
    font-size: 13.5px;
    color: var(--muted);
    text-align: center;
  }
</style>
